import styled, { css } from 'styled-components';
import colors from '@designSystem/colors';

export const BlockSpan = styled.span`
  display: block;
`;

export const StyledLoaderContainer = styled(BlockSpan)`
  height: 100px;
`;

export const loaderExtraStyle = css`
  top: 90px;
  left: 0;
  right: 0;
  position: absolute;
`;

export const Icon = styled(BlockSpan)`
  float: right;
  font-size: 20px;
  opacity: 0.5;
`;

export const IconAsc = styled(BlockSpan)`
  float: right;
  font-size: 20px;
  color: #02bf8e;
  transform: rotate(180deg);
  position: relative;
  top: 16px;
`;

export const IconDesc = styled(BlockSpan)`
  float: right;
  font-size: 20px;
  color: #02bf8e;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0 10px;
  position: relative;
  border: none;
  margin-top: 40px;
  border-collapse: separate;

  thead tr {
    background: transparent;
    &:hover {
      box-shadow: none;
    }
  }

  & td,
  th {
    font-family: arial;
    text-align: left;
    border: none;
    border-collapse: collapse;
    font-weight: normal;

    padding-right: 10px;

    &:first-child {
      padding-left: 24px;
    }
  }

  & th {
    text-transform: uppercase;
    color: ${colors.darkGrey};
    position: relative;
    font-size: 14px;

    .sort-icons {
      display: inline-block;
      margin-left: 7px;
      height: 13px;
      & span {
        margin-top: -12px;
      }
    }

    svg {
      width: 13px;
      margin-right: 4px;
    }

    & > span {
      display: flex;
      align-items: center;
      min-height: 13px;
    }
  }

  & tr {
    background-color: white;
    font-weight: 500;
    border-radius: 4px;

    &:hover {
      box-shadow: 0 4px 24px #ddd;
    }
  }

  & td {
    vertical-align: middle;
    color: #565655;
    font-size: 16px;
    line-height: 24px;
    padding: 16px 16px 16px 0px;

    &:first-child {
      padding: 16px 16px 16px 24px;
      border-radius: 4px 0px 0px 4px;
    }

    &:last-child {
      border-radius: 0px 4px 4px 0px;
    }
  }

  & .amber {
    color: #ff9900;
  }
  & .red {
    color: #ff0000;
  }
  & .green {
    color: #02bf8e;
  }
`;

export const TableContainer = styled.section<{
  padding?: boolean;
}>`
  min-height: 80vh;
  padding: ${({ padding }): string => (padding ? '0px 64px 64px' : '0px')};
  overflow: auto;
  & table {
    & thead th {
      color: #8d8c91;
      vertical-align: bottom;
    }

    @media (max-width: 764px) {
      min-width: 1000px;
    }
  }

  @media (max-width: 764px) {
    padding: 0 32px;
  }

  & .tableOuter {
    @media (max-width: 764px) {
      overflow-y: scroll;
    }
  }
`;
